module.exports = __webpack_public_path__ + "static/media/logoStore.34d77656.png";